<template>
  <header class="header">
    <div class="search-wrapper">
      <app-search @enter="search" />
    </div>

    <users-creation-modal @created="reloadUsersTable" />
  </header>
</template>
<script>
import AppSearch from "@components/Search";
import UsersCreationModal from "@views/users/components/UsersCreationModal";
import EventBus from "@packages/event-bus";

export default {
  components: {
    AppSearch,
    UsersCreationModal,
  },

  methods: {
    reloadUsersTable() {
      EventBus.$emit("RELOAD_USER_TABLE");
    },
    search(val) {
      //todo - search user
      EventBus.$emit("SEARCH_USER_TABLE", val);
    },
  },
};
</script>
<style scoped  lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
